<template>
  <div class="help">
    <Help/>
  </div>
</template>

<script>
// @ is an alias to /src
import Help from '@/components/Help.vue'

export default {
  name: 'help',
  components: {
    Help
  }
}
</script>